import { Subject } from 'rxjs';
import type { KostDataImportDatasetInputProcessorProgressEvent } from './input-processor-progress-event';

/** Progress of the dataset processing, as the worker posts it to the UI. */
export interface KostDataImportDatasetInputProgress {
  progress: number;
  /** A step id of the processor (`CASE_READING`) or a log line. */
  currentStep: string;
  /**
   * Share of `currentStep` done, 0–100, when it is a step id of the
   * processor; `null` for a log line.
   */
  stepPercent?: number | null;
  type: 'CURRENT_STEP_UPDATE' | 'STEP_UPDATE' | null;
}

export class KostDataImportDatasetInputProcessorProgressHandler {
  public progress$ = new Subject<KostDataImportDatasetInputProgress>();

  public log: string[] = [];

  constructor(private _stepDisplayNames: { [key: string]: string }) {}

  public update(event: KostDataImportDatasetInputProcessorProgressEvent): void {
    const steps = Object.keys(this._stepDisplayNames);
    const stepIndex = steps.indexOf(event.step);
    const percentPerStep = 100 / steps.length;
    const progressInPercent =
      stepIndex * percentPerStep + (event.current / event.max) * percentPerStep;
    const type: 'CURRENT_STEP_UPDATE' | 'STEP_UPDATE' | null =
      event?.type?.name$;

    if (type === 'STEP_UPDATE') {
      this.log.push(type);
    }

    this.progress$.next({
      currentStep: event.step,
      progress: progressInPercent,
      stepPercent:
        stepIndex >= 0 && event.max > 0
          ? (event.current / event.max) * 100
          : null,
      type,
    });
  }
}
